const DashboardIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="dashboard">
        <path
          d="M3 3H10V10H3V3Z"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 3H21V10H14V3Z"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 14H21V21H14V14Z"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 14H10V21H3V14Z"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default DashboardIcon;
